import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

/** The settings being saved. The handler runs the same admin-only guard as the
 * Mongo update-team path, then mirrors the subtrees whole (Mongo-save parity). */
export const saveManagedReturnsSettings = unaryRpc({
  name: "saveManagedReturnsSettings" as const,
  input: z.object({
    settings: z.object({
      redoManagedReturns: z.any().optional(),
      reFulfillment: z.any().optional(),
    }),
  }),
  output: z.object({ ok: z.literal(true) }),
});
